import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/locales/en.json";
import cs from "@/locales/cs.json";
import sk from "@/locales/sk.json";
import de from "@/locales/de.json";
import pl from "@/locales/pl.json";
import fr from "@/locales/fr.json";
import it from "@/locales/it.json";
import es from "@/locales/es.json";
import uk from "@/locales/uk.json";
import ru from "@/locales/ru.json";

const STORAGE_KEY = "spotcar-locale";
const SUPPORTED = ["en", "cs", "sk", "de", "pl", "fr", "it", "es", "uk", "ru"];

function detectLanguage() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED.includes(stored)) return stored;
    const nav = navigator.language.split("-")[0];
    if (SUPPORTED.includes(nav)) return nav;
    return "en";
}

const resources = {
    en: { translation: en },
    cs: { translation: cs },
    sk: { translation: sk },
    de: { translation: de },
    pl: { translation: pl },
    fr: { translation: fr },
    it: { translation: it },
    es: { translation: es },
    uk: { translation: uk },
    ru: { translation: ru },
};

i18n.use(initReactI18next).init({
    resources,
    lng: detectLanguage(),
    fallbackLng: "en",
    interpolation: { escapeValue: false },
});

export default i18n;
